import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  constructor(private httpClient: HttpClientService) {}

  static emailValidator(control: any) {
    // RFC 2822 compliant regex
    if (control.value != "") {
        if (control.value.match(/[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return null;
        } else {
            return { 'emailValidator': true };
        }
    } else {
        return null;
    }
}

static passwordValidator(control: any) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
        return null;
    } else {
        return { 'invalidPassword': true };
    }
}

static digitValidator(control: any) {
    if (control.value.match(/^[0-9]*$/)) {
        return null;
    } else {
        return { 'invalidNumber': true };
    }
}
}
